module.exports = __webpack_public_path__ + "img/thumbnail_GiantOtter_m_normal.56a5fa72.png";